
import axios from 'axios';

import * as bootstrap from 'bootstrap'
import * as Popper from "@popperjs/core"

let createPopper = Popper.createPopper

declare global {
	interface Window {
		bootstrap: typeof bootstrap;
		Popper: typeof Popper;
		createPopper: typeof createPopper;
		axios: typeof axios;
		loaded: boolean;
	}
}

window.Popper = Popper;

window.bootstrap = bootstrap;
window.axios = axios;
window.loaded = true;

console.log("Bundle loaded.");
